<template>
  <div class="apply-invoice-dialog">
  <FormDialog
    :visible="visible"
    title="申请开票"
    :width="1140"
    @close="$emit('close')"
  >
    <div class="apply-invoice__layout">
      <div class="apply-invoice__main">
        <el-form
          ref="applyForm"
          :model="form"
          :rules="rules"
          label-width="110px"
          label-position="right"
          @submit.native.prevent
        >
          <el-form-item label="订单金额">
            <span class="apply-invoice__amount">￥{{ orderAmount }}</span>
          </el-form-item>
          <el-form-item label="发票种类" prop="invoiceCategory">
            <el-radio-group v-model="form.invoiceCategory">
              <el-radio :label="0">普票</el-radio>
              <el-radio :label="1">专票</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="抬头类型" prop="invoiceType">
            <el-radio-group v-model="form.invoiceType">
              <el-radio v-if="canSelectPersonal" :label="0">个人</el-radio>
              <el-radio :label="1">企业</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票抬头" prop="title">
            <div class="apply-invoice__field">
              <el-input
                v-model="form.title"
                placeholder="请输入发票抬头"
                maxlength="128"
              />
              <!-- 从抬头管理选择已保存的抬头 -->
              <el-dropdown trigger="click" @command="onSelectTitle">
                <span class="apply-invoice__select-btn">
                  选择<i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="filteredTitleList.length">
                    <el-dropdown-item
                      v-for="item in filteredTitleList"
                      :key="item.id"
                      :command="item"
                    >
                      <span v-if="isTitleDefault(item)" class="apply-invoice__default">默认</span>
                      <span v-if="hasFilteredTitleDefault && !isTitleDefault(item)" style="width: 40px;display: inline-block;"></span>
                      <span>{{ item.title || '—' }}</span>
                    </el-dropdown-item>
                  </template>
                  <el-dropdown-item v-else disabled>暂无数据</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 设为默认（暂时隐藏）
              <el-checkbox v-model="form.setDefaultTitle" class="apply-invoice__default-check">
                设为默认
              </el-checkbox>
              -->
            </div>
          </el-form-item>
          <template v-if="isEnterprise">
            <el-form-item label="纳税人识别号" prop="taxNo">
              <el-input
                v-model="form.taxNo"
                placeholder="请输入纳税人识别号"
                maxlength="64"
              />
            </el-form-item>
            <el-form-item label="注册地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入注册地址"
                maxlength="256"
              />
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入联系电话"
                maxlength="32"
              />
            </el-form-item>
            <el-form-item label="开户行" prop="bankName">
              <el-input
                v-model="form.bankName"
                placeholder="请输入开户行"
                maxlength="128"
              />
            </el-form-item>
            <el-form-item label="银行账号" prop="bankAccount">
              <el-input
                v-model="form.bankAccount"
                placeholder="请输入银行账号"
                maxlength="64"
              />
            </el-form-item>
          </template>
          <el-form-item label="收票邮箱" prop="email">
            <div class="apply-invoice__field">
              <el-input
                v-model="form.email"
                placeholder="请输入收票邮箱"
                maxlength="128"
              />
              <!-- 从抬头管理选择已保存的邮箱 -->
              <el-dropdown trigger="click" @command="onSelectEmail">
                <span class="apply-invoice__select-btn">
                  选择<i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="emailList.length">
                    <el-dropdown-item
                      v-for="item in emailList"
                      :key="item.id"
                      :command="item"
                    >
                      <span v-if="isEmailDefault(item)" class="apply-invoice__default">默认</span>
                      <span v-if="hasEmailDefault && !isEmailDefault(item)" style="width: 40px;display: inline-block;"></span>
                      <span>{{ item.email || '—' }}</span>
                    </el-dropdown-item>
                  </template>
                  <el-dropdown-item v-else disabled>暂无数据</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 设为默认（暂时隐藏）
              <el-checkbox v-model="form.setDefaultEmail" class="apply-invoice__default-check">
                设为默认
              </el-checkbox>
              -->
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="apply-invoice__preview-panel">
        <div class="apply-invoice__preview-head">
          <span class="apply-invoice__preview-title">发票预览<span style="color: #f14545;">（仅供参考）</span></span>
          <button
            type="button"
            class="apply-invoice__preview-link"
            @click="openPreviewZoom"
          >
            <i class="el-icon-search"></i>预览
          </button>
        </div>
        <div class="apply-invoice__preview-box">
          <template v-if="previewImageCaptureEnabled">
            <div v-if="previewLoading" class="apply-invoice__preview-status">预览生成中...</div>
            <img
              v-else-if="previewImageUrl"
              class="apply-invoice__preview-img"
              :src="previewImageUrl"
              alt="发票预览"
            />
            <div v-else class="apply-invoice__preview-status">暂无预览</div>
          </template>
          <div v-else class="apply-invoice__preview-html">
            <InvoicePreview :data="invoicePreviewData" />
          </div>
        </div>
      </div>
    </div>

    <!-- 离屏渲染，供 html2canvas 截图 -->
    <InvoicePreview
      v-if="previewImageCaptureEnabled"
      ref="invoicePreviewCapture"
      offscreen
      :data="invoicePreviewData"
    />

    <template slot="footer" >
      <el-button
        class="indiv-btn"
        type="primary"
        size="small"
        :loading="submitting"
        @click="onSubmit"
      >
        提交
      </el-button>
    </template>
  </FormDialog>

  <FormDialog
    :visible="previewZoomVisible"
    :width="860"
    :close-on-click-modal="true"
    @close="onPreviewZoomClosed"
  >
    <template #title>
      发票预览<span style="color: #f14545;">（仅供参考）</span>
    </template>
    <div class="apply-invoice__zoom-body">
      <template v-if="previewImageCaptureEnabled">
        <div v-if="previewZoomLoading" class="apply-invoice__zoom-status">预览生成中...</div>
        <img
          v-else-if="previewZoomUrl"
          class="apply-invoice__zoom-img"
          :src="previewZoomUrl"
          alt="发票预览"
        />
        <div v-else class="apply-invoice__zoom-status">暂无预览</div>
      </template>
      <InvoicePreview v-else :data="invoicePreviewData" />
    </div>
  </FormDialog>
  </div>
</template>

<script>
/** 申请开票弹窗：抬头/邮箱选择、默认预填、提交开票申请 */
import {
  fetchInvoiceTitleList,
  fetchDefaultInvoiceTitle,
  fetchEmailList,
  fetchDefaultEmail,
} from '../TitleManage/api';
import { applyInvoice } from './api';
import InvoicePreview from './InvoicePreview.vue';
import { INVOICE_PREVIEW_CONFIG } from './constants';

/** 专票（invoiceCategory=1）时必填的企业字段 */
const SPECIAL_INVOICE_FIELD_KEYS = ['address', 'phone', 'bankName', 'bankAccount'];

const SPECIAL_INVOICE_FIELD_MESSAGES = {
  address: '请输入注册地址',
  phone: '请输入联系电话',
  bankName: '请输入开户行',
  bankAccount: '请输入银行账号',
};

function isSpecialInvoiceCategory(invoiceCategory) {
  return Number(invoiceCategory) === 1;
}

function buildSpecialInvoiceFieldRules() {
  const rules = {};
  SPECIAL_INVOICE_FIELD_KEYS.forEach((key) => {
    rules[key] = [
      {
        required: true,
        message: SPECIAL_INVOICE_FIELD_MESSAGES[key],
        trigger: ['blur', 'change'],
      },
    ];
  });
  return rules;
}

const EMPTY_FORM = {
  invoiceType: 0,
  invoiceCategory: 0,
  title: '',
  taxNo: '',
  address: '',
  phone: '',
  bankName: '',
  bankAccount: '',
  email: '',
  setDefaultTitle: false,
  setDefaultEmail: false,
};

export default {
  name: 'ApplyInvoiceDialog',
  components: {
    InvoicePreview,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** 当前申请开票的订单 */
    order: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      form: { ...EMPTY_FORM },
      titleList: [],
      emailList: [],
      previewImageUrl: '',
      previewLoading: false,
      previewCaptureTimer: null,
      previewZoomVisible: false,
      previewZoomUrl: '',
      previewZoomLoading: false,
    };
  },
  computed: {
    previewImageCaptureEnabled() {
      return INVOICE_PREVIEW_CONFIG.imageCapture;
    },
    /** 传给发票预览组件的数据 */
    invoicePreviewData() {
      const order = this.order || {};
      return {
        invoiceType: this.form.invoiceType,
        invoiceCategory: this.form.invoiceCategory,
        title: this.form.title,
        taxNo: this.form.taxNo,
        address: this.form.address,
        phone: this.form.phone,
        bankName: this.form.bankName,
        bankAccount: this.form.bankAccount,
        email: this.form.email,
        amount: order.amount,
        serviceName: order.orderTypeText || '软件服务费',
      };
    },
    isEnterprise() {
      return Number(this.form.invoiceType) === 1;
    },
    canSelectPersonal() {
      return !isSpecialInvoiceCategory(this.form.invoiceCategory);
    },
    isSpecialInvoice() {
      return isSpecialInvoiceCategory(this.form.invoiceCategory);
    },
    /** 当前抬头类型下可选的抬头列表 */
    filteredTitleList() {
      const type = Number(this.form.invoiceType) === 0 ? 0 : 1;
      return this.titleList.filter(
        (item) => (Number(item.invoiceType) === 0 ? 0 : 1) === type
      );
    },
    /** 过滤后列表中是否存在默认项 */
    hasFilteredTitleDefault() {
      return this.filteredTitleList.some((item) => Number(item.isDefault) === 1);
    },
    orderAmount() {
      if (!this.order || this.order.amount == null) return '0.00';
      return String(this.order.amount);
    },
    /** 邮箱列表中是否存在默认项 */
    hasEmailDefault() {
      return this.emailList.some((item) => Number(item.isDefault) === 1);
    },
    rules() {
      const rules = {
        invoiceCategory: [
          { required: true, message: '请选择发票种类', trigger: 'change' },
        ],
        invoiceType: [
          { required: true, message: '请选择抬头类型', trigger: 'change' },
        ],
        title: [
          { required: true, message: '请输入发票抬头', trigger: ['blur', 'change'] },
        ],
        email: [
          { required: true, message: '请输入收票邮箱', trigger: ['blur', 'change'] },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: ['blur', 'change'] },
        ],
      };
      if (this.isEnterprise) {
        rules.taxNo = [
          {
            required: true,
            message: '请输入纳税人识别号',
            trigger: ['blur', 'change'],
          },
        ];
        if (this.isSpecialInvoice) {
          Object.assign(rules, buildSpecialInvoiceFieldRules());
        }
      }
      return rules;
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm();
        return;
      }
      this.loadOptionsAndPrefill();
      if (this.previewImageCaptureEnabled) {
        this.scheduleCapturePreview();
      }
    },
    'form.invoiceType'(val, oldVal) {
      this.$nextTick(() => {
        const form = this.$refs.applyForm;
        if (form) {
          form.clearValidate(['taxNo', ...SPECIAL_INVOICE_FIELD_KEYS]);
        }
      });
      if (oldVal !== undefined && val !== oldVal) {
        // 个人仅支持普票
        if (Number(val) === 0) {
          this.form.invoiceCategory = 0;
        }
        this.applyTitleForType(val);
      }
      if (this.previewImageCaptureEnabled) {
        this.scheduleCapturePreview();
      }
    },
    'form.invoiceCategory'(val, oldVal) {
      this.$nextTick(() => {
        const form = this.$refs.applyForm;
        if (form) form.clearValidate(SPECIAL_INVOICE_FIELD_KEYS);
      });
      // 专票仅支持企业抬头
      if (oldVal !== undefined && val !== oldVal && isSpecialInvoiceCategory(val)) {
        if (Number(this.form.invoiceType) === 0) {
          this.form.invoiceType = 1;
          this.applyTitleForType(1);
        }
      }
      if (this.previewImageCaptureEnabled) {
        this.scheduleCapturePreview();
      }
    },
    invoicePreviewData: {
      deep: true,
      handler() {
        if (!this.visible || !this.previewImageCaptureEnabled) return;
        this.scheduleCapturePreview();
      },
    },
  },
  methods: {
    scheduleCapturePreview() {
      if (!this.previewImageCaptureEnabled) return;
      if (this.previewCaptureTimer) {
        clearTimeout(this.previewCaptureTimer);
      }
      this.previewCaptureTimer = window.setTimeout(() => {
        this.previewCaptureTimer = null;
        this.$nextTick(() => {
          this.capturePreviewImage();
        });
      }, 200);
    },
    captureInvoiceImage() {
      const preview = this.$refs.invoicePreviewCapture;
      if (!preview || typeof preview.captureImage !== 'function') {
        return Promise.reject(new Error('发票预览组件不可用'));
      }
      return preview.captureImage();
    },
    capturePreviewImage() {
      if (!this.visible || !this.previewImageCaptureEnabled) {
        return Promise.resolve('');
      }

      this.previewLoading = true;
      return this.captureInvoiceImage()
        .then((url) => {
          this.previewImageUrl = url;
          return url;
        })
        .catch(() => {
          this.previewImageUrl = '';
          this.$message.error('发票预览生成失败');
          return '';
        })
        .finally(() => {
          this.previewLoading = false;
        });
    },
    openPreviewZoom() {
      if (!this.visible) return;

      this.previewZoomVisible = true;
      if (!this.previewImageCaptureEnabled) return;

      this.previewZoomLoading = true;
      this.previewZoomUrl = '';

      this.$nextTick(() => {
        window.setTimeout(() => {
          this.captureInvoiceImage()
            .then((url) => {
              this.previewZoomUrl = url;
              this.previewImageUrl = url;
            })
            .catch(() => {
              this.previewZoomVisible = false;
              this.$message.error('发票预览生成失败');
            })
            .finally(() => {
              this.previewZoomLoading = false;
            });
        }, 80);
      });
    },
    onPreviewZoomClosed() {
      this.previewZoomVisible = false;
      this.previewZoomUrl = '';
      this.previewZoomLoading = false;
    },
    /** 打开弹窗时加载抬头/邮箱列表，并用默认项预填 */
    loadOptionsAndPrefill() {
      this.form = { ...EMPTY_FORM };
      this.titleList = [];
      this.emailList = [];

      Promise.all([
        fetchInvoiceTitleList(),
        fetchEmailList(),
        fetchDefaultInvoiceTitle(),
        fetchDefaultEmail(),
      ])
        .then(([titles, emails, defaultTitle, defaultEmail]) => {
          this.titleList = titles || [];
          this.emailList = emails || [];
          if (defaultTitle) this.fillTitleFromRow(defaultTitle);
          if (defaultEmail && defaultEmail.email) {
            this.form.email = defaultEmail.email;
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            const form = this.$refs.applyForm;
            if (form) form.clearValidate();
            if (this.previewImageCaptureEnabled) {
              this.scheduleCapturePreview();
            }
          });
        });
    },
    isTitleDefault(row) {
      return Number(row.isDefault) === 1;
    },
    isEmailDefault(row) {
      return Number(row.isDefault) === 1;
    },
    /** 按抬头类型预填默认抬头，无匹配则清空抬头字段 */
    applyTitleForType(invoiceType) {
      const type = Number(invoiceType) === 0 ? 0 : 1;
      const matched = this.titleList.filter(
        (item) => (Number(item.invoiceType) === 0 ? 0 : 1) === type
      );
      const pick = matched.find((item) => Number(item.isDefault) === 1);
      if (pick) {
        this.fillTitleFromRow(pick);
        return;
      }
      this.form.invoiceType = type;
      this.form.title = '';
      this.form.taxNo = '';
      this.form.address = '';
      this.form.phone = '';
      this.form.bankName = '';
      this.form.bankAccount = '';
    },
    /** 将抬头数据填入表单 */
    fillTitleFromRow(data) {
      const invoiceType = Number(data.invoiceType) === 0 ? 0 : 1;
      const next = {
        ...this.form,
        invoiceType,
        title: data.title || '',
        taxNo: invoiceType === 1 ? (data.taxNo || '') : '',
        address: invoiceType === 1 ? (data.address || '') : '',
        phone: invoiceType === 1 ? (data.phone || '') : '',
        bankName: invoiceType === 1 ? (data.bankName || '') : '',
        bankAccount: invoiceType === 1 ? (data.bankAccount || '') : '',
      };
      if (invoiceType === 0) {
        next.invoiceCategory = 0;
      }
      this.form = next;
    },
    onSelectTitle(row) {
      if (!row) return;
      this.fillTitleFromRow(row);
      this.$nextTick(() => {
        const form = this.$refs.applyForm;
        if (form) form.clearValidate();
        if (this.previewImageCaptureEnabled) {
          this.scheduleCapturePreview();
        }
      });
    },
    onSelectEmail(row) {
      if (!row) return;
      this.form.email = row.email || '';
      if (this.previewImageCaptureEnabled) {
        this.scheduleCapturePreview();
      }
    },
    resetForm() {
      this.form = { ...EMPTY_FORM };
      this.submitting = false;
      this.previewImageUrl = '';
      this.previewLoading = false;
      this.previewZoomVisible = false;
      this.previewZoomUrl = '';
      this.previewZoomLoading = false;
      if (this.previewCaptureTimer) {
        clearTimeout(this.previewCaptureTimer);
        this.previewCaptureTimer = null;
      }
    },
    close() {
      this.$emit('close');
    },
    onSubmit() {
      const form = this.$refs.applyForm;
      if (!form || this.submitting || !this.order) return;
      form.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        const payload = {
          orderId: this.order.orderId,
          invoiceType: this.form.invoiceType,
          invoiceCategory: Number(this.form.invoiceType) === 0 ? 0 : this.form.invoiceCategory,
          title: String(this.form.title || '').trim(),
          setDefaultTitle: this.form.setDefaultTitle ? 1 : 0,
          setDefaultEmail: this.form.setDefaultEmail ? 1 : 0,
        };
        if (this.isEnterprise) {
          payload.taxNo = String(this.form.taxNo || '').trim();
          payload.address = String(this.form.address || '').trim();
          payload.phone = String(this.form.phone || '').trim();
          payload.bankName = String(this.form.bankName || '').trim();
          payload.bankAccount = String(this.form.bankAccount || '').trim();
        }
        const email = String(this.form.email || '').trim();
        payload.email = email;

        applyInvoice(payload)
          .then(() => {
            this.$emit('success');
            this.close();
          })
          .catch((err) => {
            this.$message.error((err && err.message) || '申请失败');
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.apply-invoice__layout {
  display: flex;
  gap: 40px;
  height: 582px;
}

.apply-invoice__main {
  flex: 1.1;
}

.apply-invoice__preview-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.apply-invoice__preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.apply-invoice__preview-title {
  font-size: 14px;
  font-weight: 500;
  color: #181e2d;
  line-height: 20px;
}

.apply-invoice__preview-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: none;
  font-size: 14px;
  color: #5b85ff;
  line-height: 20px;
  cursor: pointer;
}

.apply-invoice__preview-link i {
  font-size: 14px;
}

.apply-invoice__preview-box {
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  background: #fafafa;
  padding: 16px 12px;
  margin-bottom: 23px;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.apply-invoice__preview-img {
  display: block;
  width: 100%;
  height: auto;
}

.apply-invoice__preview-status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #909399;
}

.apply-invoice__preview-html {
  width: 100%;
  display: flex;
  justify-content: center;
}

.apply-invoice__zoom-body {
  padding-bottom: 28px;
}

.apply-invoice__zoom-status {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #909399;
}

.apply-invoice__zoom-img {
  display: block;
  width: 100%;
  max-height: 75vh;
  object-fit: contain;
}

.apply-invoice__amount {
  font-size: 16px;
  font-weight: 600;
  color: #f14545;
}

/* 输入框 + 选择按钮横向排列 */
.apply-invoice__field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.apply-invoice__default-check {
  flex-shrink: 0;
  margin-left: 0;
  margin-right: 0;
  height: 32px;
  padding: 0 0px;
  line-height: 30px;
  box-sizing: border-box;
}

.apply-invoice__default-check >>> .el-checkbox__label {
  line-height: 30px;
  padding-left: 8px;
}

.apply-invoice__field .el-input {
  flex: 1;
}

/* 选择按钮：80×32，描边样式 */
.apply-invoice__select-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 32px;
  font-size: 14px;
  color: #5b85ff;
  border: 1px solid #5b85ff;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
  flex-shrink: 0;
}

.apply-invoice__select-btn i {
  margin-left: 4px;
  font-size: 12px;
}

/* 默认标签，与抬头管理列表一致 */
.apply-invoice__default {
  display: inline-block;
  margin-right: 6px;
  padding: 1px 6px;
  font-size: 11px;
  line-height: 16px;
  color: #fff;
  background: #f9972d;
  border-radius: 3px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/view/client/personal-center/panels/InvoiceCenter/ApplyInvoiceDialog.vue